
export default function PartnerContent() {
  return (
    <section className="py-12 sm:py-20 px-4 sm:px-6 bg-white">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10 sm:mb-16">
          <h2 className="text-2xl sm:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
            共に成長を目指すパートナー業者を募集
          </h2>
          <p className="text-xs sm:text-sm text-gray-500 tracking-widest uppercase">PARTNER</p>
        </div>

        <div className="space-y-4 sm:space-y-6 text-gray-700 leading-relaxed text-sm sm:text-base">
          <p>
            Refresh Laboは「win-win」として協力し合える仲間を募集しております。共に成長していきましょう！
          </p>
        </div>

        <div className="mt-10 sm:mt-16 pt-10 sm:pt-16 border-t border-gray-200">
          <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4 sm:mb-6">
            個人情報の利用目的
          </h3>
          <div className="space-y-3 sm:space-y-4 text-xs sm:text-sm text-gray-600 leading-relaxed">
            <p>
              お客様よりお預かりした個人情報は、以下の目的に限定し利用させていただきます。
            </p>
            <ul className="list-disc list-inside space-y-1 sm:space-y-2 ml-2 sm:ml-4">
              <li>本サービスに関する顧客管理</li>
              <li>本サービスの運営上必要な事項のご連絡</li>
            </ul>
          </div>

          <div className="mt-6 sm:mt-8 space-y-3 sm:space-y-4 text-xs sm:text-sm text-gray-600 leading-relaxed">
            <h4 className="font-bold text-gray-800 text-sm sm:text-base">
              個人情報の提供について
            </h4>
            <p>
              当社ではお客様の同意を得た場合または法令に定められた場合を除き、取得した個人情報を第三者に提供することはいたしません。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
